"use client";
import { ICPServiceOtherType1 } from "@/types/global";


interface Props {
    data: ICPServiceOtherType1;
}

const ServiceAreaOtherCard = ({ data }: Props) => {
    return (
        <>
            <div className="col-md-6 col-xl-4 col-xxl-3 ">
                <div className="desilo-service-box6 bg-color-2">
                    <div>
                        <span className="service-number">
                            { data.id && data.id < 10 ? `0${data.id}` : data.id }
                        </span>
                        <div className="service-content">
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServiceAreaOtherCard;
